import { GraphQLClient } from "graphql-request";
import useAppStore from "src/stores/appStore";

import { getValidAccessToken } from "../tokenRefresh";
import { getTraceId } from "../traceId";
import { normalizeGraphQLError } from "./errors";

const GRAPHQL_ENDPOINT = "/graphql";

export const gqlClient = new GraphQLClient(
  `${import.meta.env.VITE_DASHBOARD_API_URL}${GRAPHQL_ENDPOINT}`,
  {
    requestMiddleware: async (req) => {
      const accessToken = await getValidAccessToken();
      const { selectedAssistant, selectedAccountId } = useAppStore.getState();
      // graphql-request v7 passes req.headers as a Headers instance, which does not
      // spread via `{...req.headers}`. Normalize to a plain object so library-set
      // defaults (Content-Type: application/json, Accept: ...) survive the merge.
      const existing = req.headers instanceof Headers
        ? Object.fromEntries(req.headers.entries())
        : req.headers;
      return {
        ...req,
        headers: {
          ...existing,
          "account-id": selectedAccountId,
          "room-id": selectedAssistant?.assistantId,
          "trace-id": getTraceId(),
          "Authorization": `Bearer ${accessToken}`
        }
      };
    },
    responseMiddleware: (response) => {
      if (response instanceof Error) {
        normalizeGraphQLError(response);
      }
    }
  }
);
